import { ApolloError } from "@apollo/client";
import { createClient } from "lib/apollo";
import Auth from "lib/auth";

const loginClient = createClient(true)
const auth = new Auth();

export type SignupFormProps = {
  acknowledged: boolean;
  setErrMsg: Function;
  signUpMutation: Function;
  loginMutation: Function;
  email: string;
  gender: string;
  dateOfBirth: string;
  password: string;
  phoneNumber: string;
  preferredGames: { [key: string]: string }[] | string;
  name: string;
  nickname: string;
};

export const submitRegistrationForm = async ({
  acknowledged,
  dateOfBirth,
  gender,
  setErrMsg,
  signUpMutation,
  loginMutation,
  email,
  password,
  phoneNumber,
  preferredGames,
  name,
  nickname,
}: SignupFormProps) => {
  if (!acknowledged) {
    setErrMsg("Please accept the terms and conditions");
    setTimeout(() => setErrMsg(undefined), 1200);
    return;
  }
  auth.clearToken();
  try {
    await signUpMutation({
      variables: {
        input: {
          dateOfBirth,
          email,
          enableMFA: false,
          gender,
          name,
          locale: "en",
          password,
          phoneNumber,
          preferredGames: Array.isArray(preferredGames)
            ? preferredGames.map(({ value }) => value)
            : undefined,
          nickname,
        },
      },
    });
    const loginResult = await loginMutation({
      variables: {
        input: {
          email,
          password,
        },
      },
    });
    if (loginResult!.data!.login && loginResult?.data!.login.accessToken) {
      auth.login({
        token: loginResult.data.login.token,
      });
    }
  } catch (err) {
    console.error(err);
  }
};

export const submitLoginForm = async ({
  email,
  password,
  loginMutation,
  setErrMsg,
  error,
  next
}: {
  email: string;
  password: string;
  loginMutation: Function;
  setErrMsg: Function;
  error: ApolloError | undefined;
  next?: string
}) => {
  try {
    auth.clearToken();
    const loginResult = await loginMutation({
      variables: {
        input: {
          email,
          password,
        },
      },
      client: loginClient
    });
    if (loginResult!.data!.login && loginResult?.data!.login.accessToken) {
      auth.login({
        token: loginResult.data.login.token,
        next
      });
    }
    setErrMsg(error?.message);
    setTimeout(() => setErrMsg(undefined), 1200);
  } catch (err) {
    setErrMsg(error?.message);
    setTimeout(() => setErrMsg(undefined), 1200);
    console.error(error);
  }
};
